import { render, staticRenderFns } from "./add-human-walker-sitter.vue?vue&type=template&id=3c69094c&scoped=true&lang=pug"
import script from "./add-human-walker-sitter.js?vue&type=script&lang=js&external"
export * from "./add-human-walker-sitter.js?vue&type=script&lang=js&external"
import style0 from "./add-human-walker-sitter.vue?vue&type=style&index=0&id=3c69094c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c69094c",
  null
  
)

export default component.exports